
import   {REMINDER_SET} from '../../constants';
const initial ={
    Reminders:[],
}


const reduceReminders = (state = initial, action) => {
    let newState = state;
    switch (action.type) {
        case REMINDER_SET:
            newState.Reminders = action.payload;
            console.log("BackendSocket reduceReminders > ",action.payload)
            return Object.assign({}, newState);
        default:
            return state
    }
}

export default reduceReminders;
